import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { LicenseFeatureFlag } from 'app/models/license';
import { environment } from 'environments/environment';
import { LICENSES_URL } from 'app/tokens';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureOnDirective } from 'app/directives/feature-on.directive';

@Component({
  selector: 'sma-web-footer',
  templateUrl: 'footer.component.html',
  styleUrl: 'footer.component.scss',
  imports: [TranslateModule, FeatureOnDirective],
})
export class FooterComponent {
  protected readonly licensesUrl: string = inject(LICENSES_URL);

  @Input() imprintUrl: string | null = null;
  @Input() dataprivacyUrl: string | null = null;

  @Output() versionIntroClicked: EventEmitter<unknown> = new EventEmitter<unknown>();

  version: string = environment.version;

  readonly LicenseFeatureFlag: typeof LicenseFeatureFlag = LicenseFeatureFlag;

  onVersionIntroClicked(): void {
    this.versionIntroClicked.emit();
  }
}
